module.exports = __webpack_public_path__ + "static/media/testivelogo.40d77f89.svg";